/**
 * Blockchain Dashboard Tab
 * Wrapper for the Blockchain POC Dashboard
 */

import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';

export function BlockchainTab({ hotelId }) {
  const navigate = useNavigate();

  const handleOpenBlockchainDashboard = () => {
    // Open in new tab with hotelId
    window.open(`/admin/blockchain?hotelId=${hotelId}`, '_blank');
  };

  return (
    <div className="space-y-6" data-testid="blockchain-dashboard-tab">
      <div>
        <h2 className="text-2xl font-bold heading-font mb-2">Blockchain Dashboard</h2>
        <p className="text-muted-foreground">
          Hotel blockchain integration - manage wallets, scoring, features, and token economy
        </p>
      </div>

      <div className="flex flex-col items-center justify-center py-12 space-y-4">
        <p className="text-muted-foreground text-center max-w-md">
          The blockchain dashboard is available as a separate view for better performance and dedicated focus on Web3 features.
        </p>
        
        <Button 
          onClick={handleOpenBlockchainDashboard}
          size="lg"
          data-testid="open-blockchain-dashboard-button"
        >
          <ExternalLink className="mr-2 h-5 w-5" />
          Open Blockchain Dashboard
        </Button>

        <Button
          variant="outline"
          onClick={() => navigate(`/admin/blockchain?hotelId=${hotelId}`)}
          data-testid="go-to-blockchain-dashboard-button"
        >
          Go to Blockchain Dashboard (Same Tab)
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto pt-8">
        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">🔒 System Health</h3>
          <p className="text-sm text-muted-foreground">
            Monitor backend, blockchain, and event indexer status
          </p>
        </div>

        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">🏨 Hotel Selector</h3>
          <p className="text-sm text-muted-foreground">
            Load blockchain data for your hotel properties
          </p>
        </div>

        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">⚙️ Feature Management</h3>
          <p className="text-sm text-muted-foreground">
            Toggle blockchain features (14 modules available)
          </p>
        </div>

        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">📊 Scoring & Tiers</h3>
          <p className="text-sm text-muted-foreground">
            Calculate quality scores and run monthly rewards
          </p>
        </div>
      </div>
    </div>
  );
}
